/* Atualiza somente o contador da galeria do piloto; a navegação continua nativa. */
function initAmbarGallery() {
  const root = document.querySelector('.lurvani-ambar-pilot');
  const carousel = root?.querySelector('flickity-carousel');
  const count = root?.querySelector('.lurvani-gallery-count');
  if (!carousel || !count || carousel.dataset.ambarCountReady) return;
  carousel.dataset.ambarCountReady = 'true';
  const update = () => {
    const slides = [...carousel.querySelectorAll('.product__media-item:not(.is-filtered)')];
    const selected = slides.findIndex(slide => slide.classList.contains('is-selected'));
    count.textContent = `${Math.max(0, selected) + 1} / ${slides.length}`;
  };
  carousel.addEventListener('flickity:ready', update);
  carousel.addEventListener('flickity:slide-changed', update);
  update();
}
initAmbarGallery();
document.addEventListener('shopify:section:load', initAmbarGallery);
